import React from 'react'
import Button from '@components/common/Button/Button.component'
import './AccountsHeaderActionButton.component.css'

type AccountsHeaderActionButtonProps = {
  children: React.ReactNode
  onClick?: () => void
  onCancel?: () => void
  cancelDisabled?: boolean
  saveDisabled?: boolean
}

const AccountsHeaderActionButton: React.FC<AccountsHeaderActionButtonProps> = ({
  children,
  onClick,
  onCancel,
  cancelDisabled = false,
  saveDisabled = false,
}) => {
  if (onCancel) {
    return (
      <div className="accounts-header-actions">
        <Button
          type="button"
          size="md"
          className="button-secondary"
          onClick={onCancel}
          disabled={cancelDisabled}
        >
          Cancel
        </Button>
        <Button
          type="button"
          size="md"
          className="button-primary"
          onClick={onClick ?? ((): void => {})}
          disabled={saveDisabled}
        >
          {children}
        </Button>
      </div>
    )
  }

  return (
    <Button
      type="button"
      size="md"
      className="button-primary"
      onClick={onClick ?? ((): void => {})}
    >
      {children}
    </Button>
  )
}

export default AccountsHeaderActionButton
